export default __webpack_public_path__ + "static/media/flask.2cca5781.svg";